export default {
  default: {
    add: 'Add',
    addItem: 'Add Item',
    newSection: 'New Section',
    noItem: 'No items added to section',
  },
}
